import { render } from "./HandSignatureTabletFormComponent.vue?vue&type=template&id=5ece98d8"
import script from "./HandSignatureTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./HandSignatureTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__